<template>
  <div class="billing-shipping-section">
    <div class="billing-section custom-fields" v-if="checkout.billingInfoFields().length > 0">
      <p :style="themeColor" class="sub-heading">{{ getBillingText }}</p>

      <!-- TODO try to use componen -->
      <!-- Too much replication -->

      <div class="clearfix double-address-fields" v-if="billingNameFields.length == 2">
        <text-field :customclass="'left'" :config="billingNameFields[0]" v-model="checkout.data[billingNameFields[0].name]"> </text-field>
        <text-field :customclass="'right'" :config="billingNameFields[1]" v-model="checkout.data[billingNameFields[1].name]"> </text-field>
      </div>

      <text-field :config="billingNameFields[0]" v-model="checkout.data[billingNameFields[0].name]" v-if="billingNameFields.length == 1">
      </text-field>

      <template v-for="field in billingOtherFields">
        <text-field :config="field" v-model="checkout.data[field.name]" v-if="field.type === 'text'"> </text-field>
      </template>

      <address-component :fields='checkout.billingInfoOnlyAddressFields()' :values="checkout.data" :label="'Billing Address'"></address-component>
    </div>

    <p class="different-shipping" v-if="combineShippingAndBilling">
      <span class="shipping-text" @click="showShippingBox()">Use a different address for shipping</span>
    </p>

    <div class="shipping-section custom-fields" v-if="!combineShippingAndBilling && checkout.shippingInfoFields().length > 0">
      <p :style="themeColor" class="sub-heading">Shipping</p>

      <div class="clearfix double-address-fields" v-if="shippingNameFields.length == 2">
        <text-field :customclass="'left'" :config="shippingNameFields[0]" v-model="checkout.data[shippingNameFields[0].name]"> </text-field>
        <text-field :customclass="'right'" :config="shippingNameFields[1]" v-model="checkout.data[shippingNameFields[1].name]"> </text-field>
      </div>

      <text-field :config="shippingNameFields[0]" v-model="checkout.data[shippingNameFields[0].name]" v-if="shippingNameFields.length == 1">
      </text-field>


      <template v-for="field in shippingOtherFields">
        <text-field :config="field" v-model="checkout.data[field.name]" v-if="field.type === 'text'"> </text-field>
      </template>

      <address-component :fields='checkout.shippingInfoOnlyAddressFields()' :values="checkout.data" :label="'Shipping Address'"></address-component>
    </div>
  </div>
</template>

<script type="text/javascript">
  import AddressComponent from "./AddressComponent.vue";
  import TextField from "./TextField.vue";

  export default {
    name: "billing-shipping-section",
    props: ['checkout'],
    components: {
      'address-component': AddressComponent,
      'text-field': TextField
    },
    data() {
      return {
        combineShippingAndBilling: this.checkout.data['shipping.ship.to.billing']
      }
    },
    methods: {
      showShippingBox() {
        this.checkout.data['shipping.ship.to.billing'] = false;
        this.combineShippingAndBilling = false;
      }
    },
    computed: {
      getBillingText() {
        return this.combineShippingAndBilling ? "Billing & Shipping" : "Billing"
      },

      billingNameFields() {
        return this.checkout.billingInfoWithoutAddressFields().filter(f => ["billing_address[first_name]", "billing_address[last_name]"].includes(f.name));
      },

      shippingNameFields() {
        return this.checkout.shippingInfoWithoutAddressFields().filter(f => ["shipping_address[first_name]", "shipping_address[last_name]"].includes(f.name));
      },

      billingOtherFields() {
        return this.checkout.billingInfoWithoutAddressFields().filter(f => !["billing_address[first_name]", "billing_address[last_name]"].includes(f.name));
      },

      shippingOtherFields() {
        return this.checkout.shippingInfoWithoutAddressFields().filter(f => !["shipping_address[first_name]", "shipping_address[last_name]"].includes(f.name));
      }
    }
  }
</script>


// WEBPACK FOOTER //
// BillingAndShippingInfo.vue?cf0098a4